import { HeaderBar } from '@dealstack/frontend/shared/components/HeaderBar/HeaderBar';
import { TEST_ELEMENT_IDS } from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { CommonReduxState } from '@dealstack/frontend/shared/globalConfig.ts';
import { getBankAccount } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investor.service.ts';
import { BankAccountSectionWithCodeValidation } from '@dealstack/frontend/shared/components/BankAccountSectionWithCodeValidation/BankAccountSectionWithCodeValidation';
import { inferBankCountryCode } from '@dealstack/frontend/shared/components/BankAccountForm/BankAccountForm.utils.ts';
import { Flex } from '@mantine/core';

export const BankingDetails = () => {
	const tCommonUI = useTranslationCommonUi();
	const userAddress = useSelector((state: CommonReduxState) => state.user.data?.address);

	const bankAccountDataRequest = useQuery({
		queryKey: ['bankAccounts'],
		queryFn: (options) => getBankAccount(false, options.signal),
	});
	const bankAccountsData = bankAccountDataRequest.data ?? [];

	return (
		<Flex direction="column" maw="40rem" pb="2rem">
			<HeaderBar tabSectionName={tCommonUI('profile.banking_details.section_name')} />
			<BankAccountSectionWithCodeValidation
				bankAccountsData={bankAccountsData}
				bankAccountsLoading={bankAccountDataRequest.isLoading}
				refetchBankAccounts={bankAccountDataRequest.refetch}
				dataTestId={TEST_ELEMENT_IDS.BANK_ACCOUNT_FORM}
				inferredCountryCode={inferBankCountryCode(userAddress?.country)}
			/>
		</Flex>
	);
};
